export function getCylinderPoints({ x, y, width, height }) {
  return [
    { x, y },
    { x: x + width, y },
    { x, y: y + height },
    { x: x + width, y: y + height },
    { x: x + width / 2, y },
    { x: x + width / 2, y: y + height },
    { x, y: y + height / 2 },
    { x: x + width, y: y + height / 2 },
  ];
}

export function getFittingPoints({ x, y, width, height, snapPoints, includeHidden = false }) {
  // Если у фитинга есть кастомные точки привязки, используем их
  if (snapPoints && Array.isArray(snapPoints)) {
    // Фильтруем скрытые точки, только если includeHidden === false
    const filteredPoints = includeHidden 
      ? snapPoints 
      : snapPoints.filter(point => !point.hidden);
    
    // ВАЖНО: Точки привязки уже трансформированы при загрузке в Canvas.js!
    // Здесь мы их НЕ трансформируем повторно.
    
    return filteredPoints.map(point => {
      if (typeof point === 'function') {
        return point(x, y, width, height);
      } else if (point.relative) {
        return { 
          x: x + width * point.x, 
          y: y + height * point.y 
        };
      } else if (point.absolute) {
        // Абсолютные координаты в мм (например, {x: 35, y: 35, absolute: true})
        return { 
          x: x + (point.x || 0), 
          y: y + (point.y || 0) 
        };
      } else {
        return { 
          x: x + (point.x || 0), 
          y: y + (point.y || 0) 
        };
      }
    });
  }
  
  // Стандартные 8 точек по умолчанию
  return [
    { x, y },                           // top-left
    { x: x + width, y },                // top-right
    { x, y: y + height },               // bottom-left
    { x: x + width, y: y + height },    // bottom-right
    { x: x + width / 2, y },            // top-middle
    { x: x + width / 2, y: y + height },// bottom-middle
    { x, y: y + height / 2 },           // left-middle
    { x: x + width, y: y + height / 2 },// right-middle
  ];
}

// Вспомогательный: поворот точки вокруг заданного пивота (в градусах)
export function rotatePointAroundPivot(point, pivot, rotationDeg) {
  const rad = (rotationDeg * Math.PI) / 180;
  const cos = Math.cos(rad);
  const sin = Math.sin(rad);
  const translatedX = point.x - pivot.x;
  const translatedY = point.y - pivot.y;
  return {
    x: pivot.x + translatedX * cos - translatedY * sin,
    y: pivot.y + translatedX * sin + translatedY * cos,
  };
}

// Возвращает 8 точек (4 угла + 4 середины сторон), повернутых вокруг (x, y)
export function getRotatedPoints({ x, y, width, height, rotation }) {
  const localPoints = [
    { x: x, y: y },
    { x: x + width, y: y },
    { x: x, y: y + height },
    { x: x + width, y: y + height },
    { x: x + width / 2, y: y },
    { x: x + width / 2, y: y + height },
    { x: x, y: y + height / 2 },
    { x: x + width, y: y + height / 2 },
  ];

  // Пивот — левый верхний угол (x, y)
  const pivot = { x, y };
  return localPoints.map((p) => rotatePointAroundPivot(p, pivot, rotation || 0));
}
